export default "__VITE_ASSET__BVtqVohe__"